import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker for PWA installability (only on the production domain).
// On the preview/dev URL we actively unregister any previously installed SW and
// clear its caches to avoid stale-code bugs during rapid iteration.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  const isProduction = window.location.hostname === "www.wallboardacademy.com" ||
                       window.location.hostname === "wallboardacademy.com" ||
                       window.location.hostname === "wallboard-academy.emergent.host";
  window.addEventListener("load", () => {
    if (isProduction) {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    } else {
      // Cleanup any lingering SW + caches from previous versions
      navigator.serviceWorker.getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .catch(() => {});
      if (window.caches?.keys) {
        caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))).catch(() => {});
      }
    }
  });
}
